module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/3_184e6a280ec14cc670ff072defa0919f.png";